import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-secondary-50">
      <header className="bg-white shadow-sm border-b border-secondary-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <span className="font-display text-2xl tracking-tight leading-none text-secondary-900">
                ONLY<span className="text-gold-700">KICKERS</span>
              </span>
            </Link>
            <Link to="/login" className="text-sm font-medium text-primary-600 hover:text-primary-500">
              Sign in
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-xl shadow-card px-8 py-10">

          <h1 className="font-display uppercase text-4xl leading-none text-ink-900 mb-2">Terms of Service</h1>
          <p className="text-sm text-secondary-500 mb-8">Effective Date: [Effective Date]</p>

          <Section>
            <p>These Terms of Service ("Terms") govern your use of onlykickers.com (the "Service"), operated by [OnlyKickers LLC] ("OnlyKickers," "we," "us," or "our"). By creating an account or using the Service, you agree to these Terms. If you do not agree, do not use the Service.</p>
          </Section>

          <Section heading="1. Eligibility">
            <p>You must be at least 13 years old to use the Service. If you are under 18, you represent that your parent or legal guardian has reviewed and agreed to these Terms on your behalf. You must provide accurate registration information and keep it current.</p>
          </Section>

          <Section heading="2. The Service">
            <p>OnlyKickers is a free, ad-supported online fantasy football platform. We do not charge fees, and we do not offer cash prizes, gift cards, or any form of cash-equivalent reward. Leagues are played for entertainment only.</p>
            <p>We may add, modify, or remove features at any time. We may also limit access to portions of the Service or the entire Service without notice.</p>
          </Section>

          <Section heading="3. Accounts">
            <p>You are responsible for your account and for all activity that occurs under it. Keep your password confidential. Notify us promptly at support@onlykickers.com if you suspect unauthorized access. You may not share your account, sell it, or transfer it to another person.</p>
            <p>We may suspend or terminate accounts that violate these Terms, harm other users, or threaten the integrity of the Service.</p>
          </Section>

          <Section heading="4. Acceptable Use">
            <p>You agree not to:</p>
            <ul>
              <li>Use the Service for any unlawful purpose or in violation of any applicable law</li>
              <li>Harass, threaten, impersonate, or harm other users</li>
              <li>Post content that is illegal, defamatory, obscene, hateful, or infringing</li>
              <li>Attempt to gain unauthorized access to the Service, other accounts, or our systems</li>
              <li>Probe, scan, or test the vulnerability of the Service except as expressly permitted</li>
              <li>Use bots, scrapers, or automated means to access the Service except for public search engine indexing</li>
              <li>Interfere with or disrupt the Service, servers, or networks</li>
              <li>Reverse engineer, decompile, or attempt to extract source code, except as permitted by law</li>
              <li>Collude with other users to manipulate league outcomes, trades, or rankings</li>
            </ul>
            <p>We reserve the right to investigate suspected violations and take appropriate action, including removing content and terminating accounts.</p>
          </Section>

          <Section heading="5. User Content">
            <p>You retain ownership of content you submit to the Service (team names, league names, messages, etc.). By submitting content, you grant us a worldwide, non-exclusive, royalty-free license to host, store, display, and use that content to operate and provide the Service.</p>
            <p>You are responsible for the content you submit. Do not submit anything you do not have the right to share.</p>
          </Section>

          <Section heading="6. Intellectual Property">
            <p>The Service, including its design, code, logos, and content created by us, is owned by [OnlyKickers LLC] and protected by intellectual property laws. We grant you a limited, non-exclusive, non-transferable, revocable license to use the Service for personal, non-commercial use in accordance with these Terms.</p>
            <p>NFL team names, player names, statistics, and related marks are the property of their respective owners. OnlyKickers is not affiliated with, endorsed by, or sponsored by the NFL, NFLPA, or any team or player.</p>
          </Section>

          <Section heading="7. Third-Party Services">
            <p>The Service integrates with third parties such as Google AdSense, Postmark, and Sentry. Your use of those services is governed by their own terms and privacy policies. We are not responsible for third-party services.</p>
          </Section>

          <Section heading="8. Advertising">
            <p>The Service displays advertising. You agree that we may serve ads in connection with the Service. We are not responsible for the content of third-party ads or for any transactions you enter into with advertisers.</p>
          </Section>

          <Section heading="9. Disclaimers">
            <p className="uppercase text-xs leading-relaxed">THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND ANY WARRANTIES ARISING FROM COURSE OF DEALING OR USAGE OF TRADE. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE OF VIRUSES. WE DO NOT WARRANT THE ACCURACY OF PLAYER STATISTICS, SCORING, OR OTHER GAME DATA, WHICH MAY DEPEND ON THIRD-PARTY SOURCES.</p>
          </Section>

          <Section heading="10. Limitation of Liability">
            <p className="uppercase text-xs leading-relaxed">TO THE MAXIMUM EXTENT PERMITTED BY LAW, [ONLYKICKERS LLC] AND ITS OFFICERS, MEMBERS, EMPLOYEES, AND AGENTS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR FOR ANY LOSS OF PROFITS, REVENUES, DATA, OR GOODWILL, ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE.</p>
            <p className="uppercase text-xs leading-relaxed">OUR TOTAL AGGREGATE LIABILITY FOR ANY CLAIM RELATED TO THE SERVICE WILL NOT EXCEED ONE HUNDRED U.S. DOLLARS ($100).</p>
            <p>Some jurisdictions do not allow the exclusion of certain warranties or limitations on liability, so some of the above may not apply to you.</p>
          </Section>

          <Section heading="11. Indemnification">
            <p>You agree to defend, indemnify, and hold harmless [OnlyKickers LLC] and its officers, members, employees, and agents from any claims, damages, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or related to your use of the Service, your content, or your violation of these Terms.</p>
          </Section>

          <Section heading="12. Termination">
            <p>You may stop using the Service and delete your account at any time. We may suspend or terminate your access at any time for any reason, including violation of these Terms. Sections that by their nature should survive termination (including intellectual property, disclaimers, limitation of liability, indemnification, and governing law) will survive.</p>
          </Section>

          <Section heading="13. Changes to These Terms">
            <p>We may update these Terms from time to time. We will post the updated version on this page and update the "Effective Date" above. If changes are material, we will provide reasonable notice. Continued use of the Service after changes take effect constitutes acceptance.</p>
          </Section>

          <Section heading="14. Governing Law and Disputes">
            <p>These Terms are governed by the laws of the State of Ohio, without regard to its conflict of laws rules. You agree that any dispute arising out of or related to these Terms or the Service will be resolved exclusively in the state or federal courts located in Lucas County, Ohio, and you consent to personal jurisdiction there.</p>
            <p>To the extent permitted by law, you and OnlyKickers each waive any right to a jury trial and any right to participate in a class action.</p>
          </Section>

          <Section heading="15. Miscellaneous">
            <p>These Terms are the entire agreement between you and OnlyKickers regarding the Service. If any provision is found unenforceable, the remaining provisions will remain in effect. Our failure to enforce a provision is not a waiver. You may not assign these Terms without our written consent; we may assign them freely.</p>
          </Section>

          <Section heading="16. Contact">
            <address className="not-italic">
              <p>[OnlyKickers LLC]</p>
              <p>[Toledo, OH street address]</p>
              <p><a href="mailto:support@onlykickers.com">support@onlykickers.com</a></p>
            </address>
          </Section>

        </div>
      </main>

      <footer className="bg-white border-t border-secondary-200 mt-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm text-secondary-500">
            <span>&copy; 2026 OnlyKickers</span>
            <span className="hidden sm:inline">·</span>
            <Link to="/privacy" className="hover:text-secondary-700">Privacy Policy</Link>
            <span className="hidden sm:inline">·</span>
            <Link to="/terms" className="hover:text-secondary-700">Terms of Service</Link>
            <span className="hidden sm:inline">·</span>
            <a href="mailto:support@onlykickers.com" className="hover:text-secondary-700">support@onlykickers.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function Section({ heading, children }: { heading?: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      {heading && (
        <h2 className="text-lg font-semibold text-secondary-900 mb-3 pb-1 border-b border-secondary-100">
          {heading}
        </h2>
      )}
      <div className="space-y-3 text-secondary-700 text-sm leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-primary-600 [&_a:hover]:text-primary-500 [&_a]:underline">
        {children}
      </div>
    </section>
  );
}
